import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';

@Component({
  selector: 'app-progress-bar',
  standalone: true,
  imports: [ProgressBarModule],
  template: `<kendo-progressbar [value]="value" [max]="max" [label]="label"></kendo-progressbar>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent {
  @Input() value = 0;
  @Input() max = 100;
  @Input() label: { visible?: boolean; position?: 'start' | 'center' | 'end' } = { visible: true };
}
